var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.225302 13.6208C-0.0751008 13.3204 -0.0751008 12.8334 0.225302 12.533L6.37915 6.37915C6.67955 6.07874 7.1666 6.07874 7.467 6.37915C7.76741 6.67955 7.76741 7.1666 7.467 7.467L2.62632 12.3077L13.0769 12.3077C16.0508 12.3077 18.4615 9.89692 18.4615 6.92308V0.76923C18.4615 0.344395 18.8059 -1.90735e-06 19.2308 -1.90735e-06C19.6556 -1.90735e-06 20 0.344395 20 0.76923V6.92308C20 10.7466 16.9004 13.8462 13.0769 13.8462L2.62632 13.8462L7.467 18.6868C7.76741 18.9872 7.76741 19.4743 7.467 19.7747C7.1666 20.0751 6.67955 20.0751 6.37915 19.7747L0.225302 13.6208Z",
    fill: "#9A9EB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f8200aeb54f83ce2571ec48526598c26.svg";
export { ForwardRef as ReactComponent };